/**
 * Colour palette according to the attachment in https://fruitfuloffice.atlassian.net/browse/NCA-821
 * Should match {@link palette.scss}
 */
const palette = {
  forest: '#00442a',
  forestPlaceholder: '#00442a80',
  forestSemitransparent: '#00442a26',
  forestTransparent: '#00442a08',
  cream: '#fbfae3',
  sky: '#a6d7f7',
  apple: '#07ca7b',
  applePlaceholder: '#07ca7b80',
  ginger: '#f4f8b8',
  white: '#ffffff',
  // For exceptional use cases
  red: '#c92137',
  redPlaceholder: '#c9213780',
}

export default palette
